module.exports = __webpack_public_path__ + "static/media/divider.1326c0c2.png";